export const getDistinctValues = (array: any[]) =>
    array.reduce((list, element) => {
        if (!list.find((l) => l === element)) list.push(element);
        return list;
    }, []);
export const getStringValue = (array: any[], seperator: string) =>
    array.reduce((string, value, i) => `${string}${value}${i < array.length - 1 ? `${seperator} ` : ''}`, '');
export const sortTimeStrings = (array: string[]) =>
    array.sort((a, b) => {
        const aDate = a < '12:01' || a === '00:00' ? Date.parse(`2023-02-02 ${a}`) : Date.parse(`2023-02-01 ${a}`);
        const bDate = b < '12:01' || b === '00:00' ? Date.parse(`2023-02-02 ${b}`) : Date.parse(`2023-02-01 ${b}`);
        return aDate - bDate;
    });

export const compareArrays = (arr1: string[], arr2: string[]): boolean => {
    if (!arr1 || !arr2 || arr1.length < 1 || arr2.length < 1) return false;
    const arr1s = arr1.sort();
    const arr2s = arr2.sort();
    return arr1s.length === arr2s.length && arr1s.every((e, index) => e === arr2s[index]);
};
export const calculatePropertySum = (array: any[], property: string): number => array.reduce((sum, item) => sum + item[property], 0);
